export default __webpack_public_path__ + "static/media/warning--domestic-animals--g1.b5ee6b47.png";